import type { TMemberTeammateState } from "@/types/teammates";

/** What the member can do with their own teammate in a given state. */
export type TMemberTeammateAction = "turn_on" | "turn_off" | "none";

/**
 * The member screen's action for each state (NG-2622, design F1/F5):
 *
 * - **active** → Turn off.
 * - **not_activated**, **paused**, **needs_consent** → Turn on, which asks for
 *   consent to the current version first.
 * - **waiting_for_admin** → nothing: the admin has not approved the current
 *   version, so the server would refuse the member's consent.
 */
export function memberTeammateAction(state: TMemberTeammateState): TMemberTeammateAction {
  switch (state) {
    case "active":
      return "turn_off";
    case "not_activated":
    case "paused":
    case "needs_consent":
      return "turn_on";
    case "waiting_for_admin":
      return "none";
  }
}
